import Layout from '../components/Layout'
// import PropTypes from 'prop-types'
import React from 'react'

export default class CareersPage extends React.Component {
  render() {
    // const Content = ({ title, subtitle, description }) => (
    //   <div className="image-details has-text-right has-text-white">
    //     <h1 className="is-size-1 has-text-white">{title}</h1>
    //     <h3 className="is-size-3">{subtitle}</h3>
    //     <p className="is-size-4">{description}</p>
    //   </div>
    // )

    return (
      <Layout>
        <img className="full-w" src="/img/careers.jpg" alt=""></img>

        <div className="has-background-white-bis section">
          <div className="container">
            <div className="column is-4 is-offset-4">
              <div className="has-text-centered">
                <p className="has-text-weight-bold brand-color">
                  Send your resume to{' '}
                  <a href="mailto:hr@caffebene.com.my">hr@caffebene.com.my</a>
                </p>

                <br />

                <p className="has-text-weight-bold is-capitalized">
                  Current Opportunities
                </p>
                <ul>
                  <li>Outlet Full Time/Part Time Baristas</li>
                  <li>Outlet Supervisor</li>
                  <li>Outlet Manager/Assistant Outlet Manager</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}
